import { BranchState } from "../../types";
import {
  CREATE_BRANCH_SUCCESS,
  FETCH_BRANCHES_SUCCESS,
  EDIT_BRANCH_SUCCESS,
  DELETE_BRANCH_SUCCESS,
  LOGOUT_USER_REQUEST
} from "../constants";

const initialState: BranchState = {
  branches: [],
};
// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: [...state.branches, action.payload.newBranch],
      };
    case FETCH_BRANCHES_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
      };
    case EDIT_BRANCH_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
      };
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
      };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
